module.exports = Object.freeze({
  OUTGOING: "outgoing",
  INCOMMING: "incomming",
});
